/** Only allow same-origin relative paths after login. */
export function getSafeRedirectPath(redirect) {
  if (!redirect || typeof redirect !== "string") return null;
  const path = redirect.trim();
  if (!path.startsWith("/") || path.startsWith("//")) return null;
  if (path.startsWith("/Login") || path.startsWith("/login")) return null;
  return path;
}

export function buildLoginPath(fromPathname = "", fromSearch = "") {
  const from = `${fromPathname}${fromSearch}`;
  if (!from || from === "/") return "/Login";
  return `/Login?redirect=${encodeURIComponent(from)}`;
}
